import { SystemApiModule } from "@src/redux/index";
import { Form, Select } from "antd";
import { startCase } from "lodash";
import React, { useEffect, useState } from "react";

interface EndPointsProps {
  apiList: SystemApiModule[];
}

const EndPoints: React.FC<EndPointsProps> = ({ apiList }) => {
  const [apiItems, setApiItems] = useState<{ label?: string; value?: string }[]>([]);

  useEffect(() => {
    const temp = apiList?.map((x) => ({
      label: startCase(x?.name),
      value: x?.id,
    }));
    setApiItems(temp || []);
  }, [apiList]);

  return (
    <>
      <Form.Item label="End Points" name={"api_module_id_list"}>
        <Select
          mode="multiple"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={apiItems}
        />
      </Form.Item>
    </>
  );
};

export default EndPoints;
